import { getCoreLevel } from '../../publicSession/selectors';
import { getMaxPriceForCoreLevel } from '../../utils/profits';
export const getMaxPrice = (state)=>{
    const coreLevel = getCoreLevel(state);
    return getMaxPriceForCoreLevel(coreLevel);
};

//# sourceMappingURL=selectors.js.map